import { MenuItem } from 'src/types'
import { AssetUrl, DefaultRole } from 'able-lib'

export interface DownloadAsset {
  assetUrls: Array<{
    id: number;
    url: Array<AssetUrl>;
  }>;
  current: Array<AssetUrl>;
  downloaded: Array<AssetUrl>;
  completed: number;
  currentDownloading: {
    id?: number;
    url: AssetUrl;
    progress: number;
    attempt: number;
    error: boolean;
  };
}

export interface LocalStateInterface {
  menus: Array<MenuItem>;
  downloadAssets: DownloadAsset;
  maintenanceInfo: {
    effective_date: string;
    message: string;
    effective_state: boolean;
  };
  assignments: {
    answered: number;
    unanswered: number;
    total: number;
  };
  currentYear: number;
  roles: Array<object>;
  levels: Array<object>;
  subjects: Array<object>;
  locations: Array<object>;
}

const state: LocalStateInterface = {
  menus: [
    {
      label: 'Dashboard',
      icon: 'solar-panel-solid',
      link: '/dashboard'
    },
    {
      label: 'Prepare Lessons',
      icon: 'edit-solid',
      link: '/lessons',
      roles: [
        DefaultRole.TEACHER,
        DefaultRole.ADMINISTRATOR
      ]
    },
    {
      label: 'E-Library',
      icon: 'local-library',
      link: '/elibrary',
      roles: [
        DefaultRole.TEACHER,
        DefaultRole.ADMINISTRATOR,
        DefaultRole.STUDENT
      ]
    },
    {
      label: 'Awards',
      icon: 'medal-solid',
      link: '/awards',
      roles: [
        DefaultRole.TEACHER,
        DefaultRole.ADMINISTRATOR,
        DefaultRole.STUDENT
      ]
    },
    {
      label: 'My Folder',
      icon: 'folder-open-solid',
      notificationSource: true,
      children: [
        {
          label: 'Assignments',
          icon: 'folder-open-solid',
          link: '/myfolder/assignments',
          notificationSource: 'assessment/getUnansweredAssignmentsCount',
          badge: 0
        },
        {
          label: 'Journals',
          icon: 'folder-open-solid',
          link: '/myfolder/journals',
          badge: 0
        },
        {
          label: 'My Files',
          icon: 'folder-open-solid',
          link: '/myfiles',
          badge: 0
        }
      ],
      roles: [
        DefaultRole.TEACHER,
        DefaultRole.ADMINISTRATOR,
        DefaultRole.STUDENT
      ]
    },
    {
      label: 'Messages',
      icon: 'comment-solid',
      link: '/messages',
      notificationSource: true,
      children: [
        {
          label: 'Chats',
          icon: 'comment-solid',
          link: '/messages/chats',
          notificationSource: 'message/unreadMessageCount',
          badge: 0
        },
        {
          label: 'General Announcements',
          icon: 'comment-solid',
          link: '/messages/general/announcements',
          badge: 0
        },
        {
          label: 'Parents Announcements',
          icon: 'comment-solid',
          link: '/messages/parents/announcements/',
          badge: 0
        }
      ]
    },
    {
      label: 'Calendar',
      icon: 'calendar-alt-regular',
      link: '/calendar'
    },
    {
      label: 'Tuition',
      icon: 'payments',
      link: '/tuition',
      roles: [
        DefaultRole.PARENT
      ]
    },
    {
      label: 'Administration',
      icon: 'users-solid',
      link: '/calendar',
      children: [
        {
          label: 'Lesson Plans',
          icon: 'address-book-solid',
          link: '/administration/lessonplans',
          roles: [
            DefaultRole.ADMINISTRATOR,
            DefaultRole.TEACHER
          ]
        },
        {
          label: 'Announcements',
          icon: 'comment-solid',
          link: '/administration/announcements',
          roles: [
            DefaultRole.ADMINISTRATOR,
            DefaultRole.TEACHER
          ]
        },
        {
          label: 'Users',
          icon: 'user-solid',
          link: '/administration/users',
          roles: [
            DefaultRole.ADMINISTRATOR,
            DefaultRole.TEACHER
          ]
        },
        {
          label: 'Sections',
          icon: 'users-solid',
          link: '/administration/sections',
          roles: [
            DefaultRole.ADMINISTRATOR,
            DefaultRole.TEACHER
          ]
        },
        {
          label: 'Tuition Tracker',
          icon: 'account-balance',
          link: '/administration/tuitions',
          roles: [
            DefaultRole.ADMINISTRATOR,
            DefaultRole.AUDITOR
          ]
        }
      ],
      roles: [
        DefaultRole.ADMINISTRATOR,
        DefaultRole.TEACHER
      ]
    },
    {
      label: 'Logout',
      icon: 'sign-out',
      link: '/logout'
    }
  ],
  downloadAssets: {
    assetUrls: [],
    downloaded: [],
    current: [],
    currentDownloading: {
      url: '',
      progress: 0,
      attempt: 0,
      error: false
    },
    completed: 0
  },
  maintenanceInfo: {
    effective_date: '',
    message: '',
    effective_state: false
  },
  assignments: {
    answered: 0,
    unanswered: 0,
    total: 0
  },
  currentYear: 0,
  roles: [],
  levels: [],
  subjects: [],
  locations: []
}

export default state
